import http from '@/requests/http'

class Group {
  static all (params) {
    return http.post('configuration/member/group/index', params)
  }
  static async view (params) {
    return http.post('configuration/member/group/view', params)
  }
  static async update (data) {
    return http.post('configuration/member/group/update', data)
  }
  static async save (data) {
    return http.post('configuration/member/group/store', data)
  }
  static async destroy (id) {
    return http.post(`configuration/member/group/delete/${id}`)
  }
}

export default Group
